import { QueryClient } from "@tanstack/react-query";
import { shouldRetryOnError, isNetworkError } from "./networkUtils";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Retry hanya untuk error jaringan, maksimal 3x dengan backoff eksponensial
      retry: (failureCount, error) => {
        if (failureCount >= 3) return false;
        return shouldRetryOnError(error);
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 10000),

      // Jangan refetch saat window focus jika ini bukan network error
      refetchOnWindowFocus: false,

      // Stale time 30 detik — data tidak segera dianggap stale
      staleTime: 30_000,

      // Jika gagal lebih dari 2x dan bukan network error, jangan coba lagi
      gcTime: 5 * 60 * 1000, // 5 menit
    },
    mutations: {
      retry: (failureCount, error) => {
        if (failureCount >= 2) return false;
        return isNetworkError(error);
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 8000),
    },
  },
});
